import { PageHeader } from "antd";
import { Fragment, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import BaseLayout from "../../../components/BaseLayout";
import ChartLayout from "../../../components/ChartLayout";
import useSpuInfo from "../../../stores/spuInfo";
import useSpuPoints from "../../../stores/spuPoints";
import Loading from "../components/Loading";
import EmptyChart from "../components/EmptyChart";
import DisplayUnitSelector from "../../SpuChart/components/DisplayUnitSelector";
import useDisplayUnits from "../../SpuChart/displayUnits/useDisplayUnits";
import PerformanceSpeedForm from "../PerformanceSpeed/PerformanceSpeedForm";
import LayeredCurveDebugChart from "../PerformanceDebug/LayeredCurveDebugChart";

const PerformanceSpeedDebug = () => {
  const { id } = useParams() as { id: string };
  const { fetch: fetchInfo, spu } = useSpuInfo();
  const { fetch: fetchPoints, name, info, dataset, performanceSpeed, loading } = useSpuPoints();
  const [searchParams, setSearchParams] = useSearchParams();
  const { displayUnits, updateDisplayUnit } = useDisplayUnits(searchParams, setSearchParams);

  useEffect(() => {
    fetchInfo(id);
    fetchPoints(id);
  }, [fetchInfo, fetchPoints, id]);

  if (loading) {
    return <Loading />;
  }

  if (!name || !dataset) {
    return <EmptyChart />;
  }

  const title = `${name || spu} Performance Speed Debug`;

  return (
    <BaseLayout title={title}>
      <PageHeader title={title} style={{ padding: "16px 0" }} />
      <ChartLayout
        chart={
          <LayeredCurveDebugChart
            info={info}
            dataset={dataset}
            performance={performanceSpeed.fieldsValue}
            displayUnits={displayUnits}
          />
        }
        form={
          <Fragment>
            <DisplayUnitSelector displayUnits={displayUnits} onChange={updateDisplayUnit} />
            <PerformanceSpeedForm displayUnits={displayUnits} />
          </Fragment>
        }
      />
    </BaseLayout>
  );
};

export default PerformanceSpeedDebug;
